<template>
  <div class="card-detail-request">
    <header>
      <div
        aria-label="Icono de datos de identificación incorrectos"
        :class="{
          'icon-container' : true,
        }"
      >
        <i
          :class="{
            'icon-container__icon' : true,
            'pi pi-user-edit': true,
          }"
        ></i>
      </div>
      <h1>
        Los datos identificativos introducidos no se han podido validar.
      </h1>
    </header>
    <section>
      <div class="body__description">
        <p>
          Asegúrate de introducir tus datos personales exactamente como
          figuran en tu documento de identificación.
        </p>
      </div>
    </section>
    <footer>
      <Button
        class="p-button-secondary"
        label="Volver al inicio"
        style="width: fit-content;"
        tabindex="0"
        @click="router.push({name: `Home`});"
        @keyup.enter="router.push({name: `Home`});"
      />
    </footer>
  </div>
</template>

<script setup>
// #region COMPONENTS COMPOSABLES
import Button from 'primevue/button/sfc';
import {useRouter} from 'vue-router';
// #endregion

// #region VUE
const router = useRouter();
// #endregion

// #region COMPONENTS COMPOSABLES
// ...
// #endregion

// #region Props, Emits
// ...
// #endregion

// #region Params, Ref, Reactives, Computed
// ...
// #endregion

// #region Functions
// ...
// #endregion

// #region Effects, Hooks
// ...
// #endregion

// #region Provide, Expose
// ...
// #endregion
</script>

<style lang="scss" scoped>
@use '@/styles/vars' as *;
@use '@/styles/breakpoints' as *;
.card-detail-request{
  align-items: center;
  display: flex;
  flex-direction: column;

  gap: $brand__boxspace--medium;
  padding: $brand__boxspace--medium * 2;

  header, section, footer{
    align-items: center;
    display: flex;
    flex-direction: column;

    text-align: center;

    gap: $brand__boxspace--medium;
  }

  header{
    gap: $brand__boxspace--medium * 2;
    .icon-container{
      background-color: $pv__color--green-alter;
      border-radius: $pv__br--circle;
      color: $pv__color--white;
      flex: 1;
      padding: $brand__boxspace--medium;
      width: fit-content;
      &__icon{
        @include media("<=phone") {
          font-size: $pv__dm__icon--largue;
        }
        @include media(">phone") {
          font-size: $pv__dm__icon--largue;
        }
      }
    }
  }

  section{
    .body__description{
      align-items: center;
      display: flex;
      flex-direction: column;
      & p {
        font-size: $pv__fs--large;
        & a{
          color: $pv__color--green-alter;
          text-decoration: underline;
        }
      }
    }
  }
}
</style>


